import { IntakeService } from "../../services/IntakeService";

export class InitialFormValuesHandlerHelper {
  static getHandler(handlerName : string) {
    if (handlerName == "intake") {
      return {
        "VraagSituatie" : IntakeService.getQuestionAndAnswer(),
        "VraagReactie" : IntakeService.getQuestionAndAnswer()
      };
    }
  }
}